import arrow from "../../assets/arrow.svg";
import { Link } from "react-router-dom";

const Chart = ({ charts }) => {
  return (
    <div className="row">
      {charts ? (
        charts.map((chart) => {
          const items = [];
          for (let i = 0; i < 3; i++) {
            items.push(
              <div className="chart-item" key={i + 1}>
                <img
                  src={chart.chartItems[i].file.src}
                  alt={chart.chartItems[i].file.title}
                />
              </div>
            );
          }
          return (
            <div
              key={chart.id}
              className="col-12 col-sm-6 col-md-4 col-lg-4 col-xl-4 chart"
            >
              <div className="dummy"></div>
              <div className="box">
                <h2 className="title">{chart.chartTitle}</h2>
                <h2 className="opacity">افضل {chart.chartLength}</h2>
                <div className="chart-items">{items}</div>
              </div>
              <Link to={`/Charts/${chart.id}`}>
                <div className="">عرض المزيد</div>
                <div className="arrow">
                  <img src={arrow} alt="" />
                </div>
              </Link>
            </div>
          );
        })
      ) : (
        <div className="row">
          <div className="col-12 col-sm-6 col-md-4 col-lg-4 col-xl-4 chart">
            <div className="dummy"></div>
            <div className="box">
              <h2 className="title">
                <div className="skeleton"></div>
              </h2>
              <h2 className="opacity">افضل 100</h2>
              <div className="chart-items">
                <div className="chart-item skeleton circle"></div>
                <div className="chart-item skeleton circle"></div>
                <div className="chart-item skeleton circle"></div>
              </div>
            </div>
            <Link>
              <div className="">
                <div className="skeleton"></div>
              </div>
              <div className="arrow">
                <img src={arrow} alt="" />
              </div>
            </Link>
          </div>
        </div>
      )}
    </div>
  );
};

export default Chart;
